import { PBR_HAS_ALPHA_TEST } from '../pbr-flag-bits.js';

const pbrExt = {
  id: "alpha-test",
  phase: "fragment",
  detect(mat) {
    return (mat._alphaCutOff ?? 0) > 0 ? { f: PBR_HAS_ALPHA_TEST, f2: 0 } : { f: 0, f2: 0 };
  },
  frag(ctx) {
    return ctx._features & PBR_HAS_ALPHA_TEST ? {
      _id: "alpha-test",
      _uboFields: [{ _name: "alphaCutOff", _type: "f32" }],
      _fragmentSlots: { AT: `if(alpha*material.materialAlpha<material.alphaCutOff){discard;}` }
    } : null;
  },
  writeUbo(data, mat, offsets) {
    const off = offsets.get("alphaCutOff");
    if (off !== void 0) {
      data[off / 4] = mat._alphaCutOff ?? 0;
    }
  }
};

export { pbrExt };
//# sourceMappingURL=alpha-test-fragment.js.map
